'use client';
import Link from 'next/link';
import React from 'react';
import get from 'lodash/get';

const PostsMain = ({ featuredEvents }) => {
  const posts = get(featuredEvents, 'results', []);
  if (!posts.length) return null;

  return (
    <div className="border border-gray-200 rounded-lg overflow-hidden h-full flex flex-col">
      {/* Header */}
      <div className="title">
        <a href="#" className="font-semibold">
          Tin mới nhất
        </a>
      </div>

      {/* List */}
      <ul className="flex-1 overflow-y-auto divide-y divide-gray-100">
        {posts.map((post) => (
          <li key={post.slug}>
            <Link
              href={`${post?.menuId?.slug}/${post.slug}`}
              className="flex flex-col gap-1 px-4 py-3 hover:bg-[#fff8e1] transition-colors duration-200 group">
              <span className="text-[13.5px] font-medium text-gray-800 group-hover:text-[#b71c1c] leading-snug line-clamp-2 transition-colors duration-200">
                {post.title}
              </span>
              {post.publishedAt && (
                <span className="text-[11px] text-gray-400 flex items-center gap-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11"
                    height="11"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10" />
                    <polyline points="12 6 12 12 16 14" />
                  </svg>
                  {new Date(post.publishedAt).toLocaleDateString('vi-VN')}
                </span>
              )}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PostsMain;
